<script>
  import * as d3 from "d3";

  export let options = [];
  export let selected = [];
  export let colors = undefined;
</script>

<div class="checkbox">
  <div class="options">
    {#each options as value, i}
      <label style={colors ? `color: ${colors[i]}` : ""}
        ><input type="checkbox" {value} bind:group={selected} />{value}</label
      >
    {/each}
  </div>
</div>

<style>
  .options {
    font-size: 12px;
  }

  .options label {
    float: none;
    color: black;
    padding: 0px 0px 5px 0px;
    text-decoration: none;
    text-align: left;
    display: flex;
    align-content: center;
  }

  .options input {
    margin-right: 5px;
    cursor: pointer;
  }
</style>
